import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const initialForm = {
  rider_name: "", age_dob: "", country: "", discipline: "", level: "",
  years_riding: "", notable_results: "", goals: "", programme_interest: "",
  preferred_start: "", how_heard: "", reviewed_cost_guide: "", budget_fit: "",
  financial_support: "", readiness: "", parent_name: "", parent_email: "",
  phone_whatsapp: "", anything_else: "",
};

const requiredFields = [
  "rider_name", "age_dob", "country", "discipline", "level",
  "goals", "programme_interest", "preferred_start", "reviewed_cost_guide",
  "budget_fit", "readiness", "parent_name", "parent_email",
];

export function useSurveyForm() {
  const [form, setForm] = useState(initialForm);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const updateField = (key, val) => setForm((prev) => ({ ...prev, [key]: val }));

  const submit = async (e) => {
    e.preventDefault();
    const missing = requiredFields.some((f) => !form[f]);
    if (missing) {
      toast.error("Please fill in all required fields");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/survey/submit`, form);
      setSubmitted(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return { form, updateField, submitted, loading, submit };
}
